/* istanbul ignore next */
var gl = ((typeof window !== 'undefined' ? window : global) || {});
// GIPHY_API_URL is made to override the api url in testing environments
// must be specified before the packages load
export var serverUrl = gl.GIPHY_API_URL || 'https://api.giphy.com/v1/';
export var setServerUrl = function (url) {
    serverUrl = url;
};
//# sourceMappingURL=constants.js.map